import React from 'react';
import { EJedeaiMetadataXSource, JedeaiMetadataXSource } from '@sgdocs/client';
import { v4 as uuidv4 } from 'uuid';

const EMPTY_BDR = '{"bdr": []}';

export const computeWidgetMapping = (
  xSource: JedeaiMetadataXSource
): {
  name: string;
  uri: string;
  render: (
    ref: any,
    onChange: (newValues: string) => void,
    value: string,
    placeholder?: string,
    readonly?: boolean
  ) => JSX.Element;
} => {
  switch (xSource) {
    case EJedeaiMetadataXSource.SPARK_MONTAGE:
      return {
        name: 'jedeai-spark-montage-multi-picker',
        uri: '/jedeai-spark-widget/jedeai-spark-pickers/jedeai-spark-montage-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-spark-montage-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"montage": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.SPARK_MONTAGE_SEARCH:
      return {
        name: 'jedeai-spark-montage-multi-picker',
        uri: '/jedeai-spark-widget/jedeai-spark-pickers/jedeai-spark-montage-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-spark-montage-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"montage": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.SPARK_PRODUCT_ISSUE:
      return {
        name: 'jedeai-spark-product-issue-multi-picker',
        uri: '/jedeai-spark-widget/jedeai-spark-pickers/jedeai-spark-product-issue-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-spark-product-issue-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"product": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.SPARK_PRODUCT_ISSUE_SEARCH:
      return {
        name: 'jedeai-spark-product-issue-multi-picker',
        uri: '/jedeai-spark-widget/jedeai-spark-pickers/jedeai-spark-product-issue-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-spark-product-issue-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"product": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.ELIOT_BASKET:
      return {
        name: 'jedeai-eliot-basket-multi-picker',
        uri: '/jedeai-eliot/jedeai-eliot-pickers/jedeai-eliot-basket-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-eliot-basket-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"basketId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.ELIOT_BASKET_SEARCH:
      return {
        name: 'jedeai-eliot-basket-multi-picker',
        uri: '/jedeai-eliot/jedeai-eliot-pickers/jedeai-eliot-basket-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-eliot-basket-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"basketId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.ELIOT_FLOW:
      return {
        name: 'jedeai-eliot-flow-multi-picker',
        uri: '/jedeai-eliot/jedeai-eliot-pickers/jedeai-eliot-flow-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-eliot-flow-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"flowId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.ELIOT_FLOW_SEARCH:
      return {
        name: 'jedeai-eliot-flow-multi-picker',
        uri: '/jedeai-eliot/jedeai-eliot-pickers/jedeai-eliot-flow-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-eliot-flow-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"flowId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.X_ONE_DEAL:
      return {
        name: 'jedeai-x-one-deal-multi-picker',
        uri: '/jedeai-x-one/jedeai-x-one-pickers/jedeai-x-one-deal-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-x-one-deal-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"dealId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.X_ONE_DEAL_SEARCH:
      return {
        name: 'jedeai-x-one-deal-multi-picker',
        uri: '/jedeai-x-one/jedeai-x-one-pickers/jedeai-x-one-deal-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-x-one-deal-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"dealId": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.GALAXY_PRODUCT:
      return {
        name: 'jedeai-galaxy-product-multi-picker',
        uri: '/jedeai-galaxy/jedeai-galaxy-pickers/jedeai-galaxy-product-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-galaxy-product-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"product": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.GALAXY_PRODUCT_SEARCH:
      return {
        name: 'jedeai-galaxy-product-multi-picker',
        uri: '/jedeai-galaxy/jedeai-galaxy-pickers/jedeai-galaxy-product-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-galaxy-product-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"product": []}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.MAESTRO_COUNTERPARTY:
      return {
        name: 'jedeai-maestro-counter-party-multi-picker',
        uri: '/jedeai-maestro/jedeai-maestro-pickers/jedeai-maestro-counter-party-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-counter-party-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        )
      };
    case EJedeaiMetadataXSource.MAESTRO_COUNTERPARTY_SEARCH:
      return {
        name: 'jedeai-maestro-counter-party-multi-picker',
        uri: '/jedeai-maestro/jedeai-maestro-pickers/jedeai-maestro-counter-party-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-counter-party-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        )
      };
    case EJedeaiMetadataXSource.MAESTRO_CARE_COUNTERPARTY:
      return {
        name: 'jedeai-maestro-care-counter-party-multi-picker',
        uri: '/jedeai-maestro-care-pickers/jedeai-maestro-care-counter-party-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-care-counter-party-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        )
      };
    case EJedeaiMetadataXSource.MAESTRO_CARE_COUNTERPARTY_SEARCH:
      return {
        name: 'jedeai-maestro-care-counter-party-multi-picker',
        uri: '/jedeai-maestro-care-pickers/jedeai-maestro-care-counter-party-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-care-counter-party-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        )
      };
    case EJedeaiMetadataXSource.MAESTRO_LEGAL_ENTITY:
      return {
        name: 'jedeai-maestro-legal-entity-multi-picker',
        uri: '/jedeai-maestro/jedeai-maestro-pickers/jedeai-maestro-legal-entity-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-legal-entity-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.MAESTRO_LEGAL_ENTITY_SEARCH:
      return {
        name: 'jedeai-maestro-legal-entity-multi-picker',
        uri: '/jedeai-maestro/jedeai-maestro-pickers/jedeai-maestro-legal-entity-multi-picker',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-maestro-legal-entity-multi-picker
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? EMPTY_BDR : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    case EJedeaiMetadataXSource.TERMSHEET_CONTROL:
      return {
        name: 'jedeai-termsheet-control-selector',
        uri: '/jedeai-control/jedeai-control-pickers/jedeai-termsheet-control-selector',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-termsheet-control-selector
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"control": ""}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'search'}
          />
        ),
      };
    case EJedeaiMetadataXSource.TERMSHEET_CONTROL_SEARCH:
      return {
        name: 'jedeai-termsheet-control-selector',
        uri: '/jedeai-control/jedeai-control-pickers/jedeai-termsheet-control-selector',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: any,
          placeholder?: string,
          readonly = false
        ): JSX.Element => (
          <jedeai-termsheet-control-selector
            ref={ref}
            id={uuidv4()}
            placeholder={placeholder}
            selected-id={!value ? '{"control": ""}' : JSON.stringify(value)}
            selected-view-mode={readonly ? 'display' : 'freeSearch'}
          />
        ),
      };
    default:
      console.error(`${xSource} is not registered on widget mapping`);
      return {
        name: '',
        uri: '',
        render: (
          ref: any,
          onChange: (newValues: string) => void,
          value: string,
          placeholder?: string,
          readonly = false
        ): JSX.Element => <></>,
      };
  }
};
